export default __webpack_public_path__ + "79099fbbe23e05ef1306f79c3e726a9e.jpg";